import type { ReactNode } from "react";

export interface MmcAction {
  label: string;
  onClick: () => void;
}

export interface MmcTreeNode {
  active?: boolean;
  icon?: ReactNode;
  id: string;
  label: string;
  onClick?: () => void;
}

export interface MmcListColumn {
  key: string;
  label: string;
}

export interface MmcListRow {
  id: string;
  values: Record<string, ReactNode>;
  onDoubleClick?: () => void;
}

export function MmcFrame({
  actions,
  children,
  columns,
  rows,
  title,
  tree
}: {
  actions: MmcAction[];
  children?: ReactNode;
  columns: MmcListColumn[];
  rows: MmcListRow[];
  title: string;
  tree: MmcTreeNode[];
}) {
  return (
    <div className="fd-mmc-frame">
      <div className="fd-mmc-menubar" aria-label={`${title} menu`}>
        <span>File</span>
        <span>Action</span>
        <span>View</span>
        <span>Help</span>
      </div>
      <div className="fd-mmc-toolbar">
        {actions.map((action) => (
          <button key={action.label} type="button" onClick={action.onClick}>{action.label}</button>
        ))}
      </div>
      <div className="fd-mmc-body">
        <aside className="fd-mmc-tree-panel" aria-label={`${title} tree`}>
          {tree.map((node) => (
            <button className={node.active ? "is-active" : ""} key={node.id} type="button" onClick={node.onClick}>
              {node.icon}
              <span>{node.label}</span>
            </button>
          ))}
        </aside>
        <main className="fd-mmc-main-panel">
          <table>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} onDoubleClick={row.onDoubleClick}>
                  {columns.map((column) => (
                    <td key={column.key}>{row.values[column.key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {children}
        </main>
      </div>
    </div>
  );
}
